import React from "react";

interface SlideEditorVideoFormProps {
    videoUrl: string;
    isRestricted: boolean;
    onFieldChange: (id: string, value: string) => void;
}

export const CarouselSlideEditorVideoForm: React.FC<SlideEditorVideoFormProps> = ({
    videoUrl,
    isRestricted,
    onFieldChange,
}) => {
    return (
        <div className="editVideoSlide">
            <section className="editSection editSection--video">
                <div className="editSection__head">
                    <h2 className="title">Video</h2>
                </div>
                <div className="videoGrid">
                    <div className="col">
                        <p>YouTube Video URL</p>
                        <input
                            id="videoUrl"
                            type="text"
                            className="input-round form-control"
                            placeholder="https://www.youtube.com/watch?v=..."
                            value={videoUrl || ""}
                            disabled={isRestricted}
                            onChange={(e) => onFieldChange("videoUrl", e.target.value)}
                        />
                        <small className="form-text text-muted">
                            Paste the full YouTube video URL. The video will autoplay muted in the carousel.
                        </small>
                    </div>
                </div>
            </section>
        </div>
    );
};